import(/* webpackMode: "eager" */ "/codebuild/output/src2180577564/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/not-found.tsx");
